/**
 * Application Constants
 */

export const APP_NAME = process.env.REACT_APP_NAME || 'LiftOff Product Launch Service';
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
// Use empty string to make relative API calls (works with proxy)
export const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * Request Types
 */
export const REQUEST_TYPES = [
  'GPR',
  'PPP',
  'Capability Update Catalog',
  'SalesOps Request',
  'Pricing & Packaging',
];

/**
 * Request Statuses
 */
export const REQUEST_STATUSES = {
  DRAFT: 'Draft',
  IN_PROGRESS: 'in_progress',
  SUBMITTED: 'submitted',
  COMPLETED: 'completed',
  VERIFIED: 'Verified',
};

export const STATUS_LABELS = {
  Draft: 'Draft',
  in_progress: 'In Progress',
  submitted: 'Submitted',
  completed: 'Completed',
  Verified: 'Verified',
};

export const STATUS_COLORS = {
  Draft: 'gray',
  in_progress: 'blue',
  submitted: 'yellow',
  completed: 'green',
  Verified: 'purple',
};

/**
 * User Roles
 */
export const USER_ROLES = {
  USER: 'user',
  APPROVER: 'approver',
  DEVELOPER: 'developer',
  ADMIN: 'admin',
};

/**
 * Table Configuration
 */
export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

/**
 * Auto-save interval (milliseconds)
 */
export const AUTO_SAVE_INTERVAL = 30000; // 30 seconds

/**
 * API Endpoints
 */
export const API_ENDPOINTS = {
  AUTH: {
    USER: '/api/auth/user',
    LOGOUT: '/api/auth/logout',
  },
  REQUESTS: {
    BASE: '/api/requests',
    BY_ID: (id) => `/api/requests/${id}`,
    AUTOSAVE: (id) => `/api/requests/${id}/autosave`,
    SUBMIT: (id) => `/api/requests/${id}/submit`,
  },
  QUESTIONS: {
    BASE: '/api/questions',
    FORM_TYPES: '/api/questions/form-types',
  },
  REPORTS: {
    BASE: '/api/reports',
    BY_ID: (id) => `/api/reports/${id}`,
    GENERATE: (id) => `/api/reports/${id}/generate`,
  },
  ADMIN: {
    METRICS: '/api/admin/metrics',
    USERS: '/api/admin/users',
    USER_STATUS: (id) => `/api/admin/users/${id}/status`,
    SEED_DATA_STATUS: '/api/admin/seed-data-status',
    LOAD_SEED_DATA: '/api/admin/load-seed-data',
  },
};

/**
 * Route Paths
 */
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  INTAKE_NEW: '/intake/new',
  INTAKE_EDIT: '/intake/:id',
  REQUEST_VIEW: '/request/:id',
  REPORTS: '/reports',
  ADMIN: '/admin',
  PROFILE: '/profile',
  LOGIN: '/login',
  CALLBACK: '/callback',
  PRODUCTS_NEW: '/products/new',
  PRODUCTS_EDIT: '/products/:id/edit',
  PRODUCTS_VIEW: '/products/:id',
  PRODUCT_HIERARCHY: '/product-hierarchy',
  HELP: '/help',
};
